import { css } from 'styled-components';
import { media } from './utils';
import { grey } from './colors';


export const heading = css`
    font-family: 'Scto';
    font-weight: 300;
    font-size: 30px;
    line-height: 32px;
    color: ${grey};

    /* 1000 - 1280 */
    ${media.laptop`
        font-size: 22.5px;
        line-height: 24px;
    `}

    /* 0 - 1000 */
    ${media.tablet`
        font-size: 18px;
        line-height: 1;
        text-align: center;
    `}
`

export const heading2 = css`
    font-family: 'Scto';
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    color: ${grey};
    
    /* 0 - 1280 */
    ${media.laptop`
        font-size: 15px;
        line-height: 18px;
    `}
`

export const paragraph = css`
    font-family: 'Scto';
    font-weight: 300;
    font-size: 18px;
    line-height: 24px;
    color: ${grey};

    &:not(:first-of-type) {
        text-indent: 5rem;
    }

    /* 0 - 1280 */
    ${media.laptop`
        font-size: 13.5px;
        line-height: 18px;
    `}
`

export const pullQuote = css`
    font-family: 'Scto';
    font-weight: 200;
    font-size: 34px;
    line-height: 36px;
    letter-spacing: -0.8px;
    text-align: center;
    color: ${grey};

    /* 1000 - 1280 */
    ${media.laptop`
        font-size: 25.5px;
        line-height: 30px;
        letter-spacing: -0.6px;
    `}

    /* 0 - 1000 */
    ${media.tablet`
        font-size: 22.5px;
        line-height: 24px;
        letter-spacing: -0.3px;
    `}
`

export const caption = css`
    font-family: 'Scto';
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: ${grey};

    &:not(:first-of-type) {
        text-indent: 5rem;
    }

    /* 0 - 1280 */
    ${media.laptop`
        font-size: 10.5px;
        line-height: 12px;
    `}
`

export const projectIntro = css`
    font-family: 'Scto';
    font-size: 22px;
    line-height: 24px;
    color: ${grey};

    &:not(:first-of-type) {
        text-indent: 5rem;
    }

    /* 0 - 1280 */
    ${media.laptop`
        font-size: 16.5px;
        line-height: 18px;
    `}
`


// WEBPACK FOOTER //
// ./src/styles/type.js